import { AsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { withMandant } from '../../../../../shared/thunks/with-mandant/with-mandant.thunk';
import { axiosInstance } from '../../../../shared/api/axios-instance';
import { createQueryParams } from '../../../../shared/utils/create-query-params/create-query-params.util';
import { Endpoints } from '../../../../shared/utils/endpoints-file.utils';
import { GetReviewsPathParams } from './models/get-reviews-params.model';

export const getReviewsTotalCount: AsyncThunk<
  number,
  GetReviewsPathParams,
  Record<string, unknown>
> = withMandant<GetReviewsPathParams, number>(
  Endpoints.REVIEW_TOTAL_COUNT,
  'reviews/get-reviews-total-count',

  async ({ args, endpoint }) => {
    const queryParams = createQueryParams({
      appId: args.appId,
      ...args.filters?.header,
    });

    const { data }: AxiosResponse<number> = await axiosInstance.get(
      endpoint + queryParams
    );

    return data;
  }
);
